import { setIsGtag, setIsLoaded, setWallet } from "./wallet"

export const updateWallet = (newWallet) => (dispatch, getState) => {
  const { wallet } = getState()

  let isEqual = true
  for (const key in wallet.data) {
    if (Object.hasOwnProperty.call(wallet.data, key)) {
      isEqual = isEqual && wallet.data[key] === newWallet[key]
    }
  }
  // console.log(isEqual, wallet.data, newWallet)
  if (isEqual) return

  if (!wallet.isGtag && newWallet && newWallet.auth) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-970914587/x8CaCM-NhvYCEJv2-84D',
      'event_callback': () => {}
    })
    dispatch(setIsGtag(true))
  }

  dispatch(setIsLoaded(true))
  dispatch(setWallet(newWallet))
}